import * as oPath from '../../../Lib/Object/Path/Mutable';
import { createSlice } from '@reduxjs/toolkit';
import {
  SetTempLoadIncrementsAction,
  SetTempLoadIncrementsValueAction,
  IPlateLoadingState,
  AddTempLoadIncrementAction,
  RemoveTempLoadIncrementAction,
  ReplaceTempLoadIncrementAction,
} from './types';
import { Guid } from 'guid-typescript';

const name = 'worksheetEditor.loadIncrements';

const initialState: IPlateLoadingState = {
  loadIncrementsManagement: {
    loadIncrements: [],
    status: {
      creating: false,
      creatingFailed: false,
      synchronising: false,
      synchronisingFailed: false,
      submissionFailed: false,
      submitting: false,
    },
  },
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    initTempLoadIncrements: (state) => {},
    autoCreateLoadIncrements: (state) => {
      state.loadIncrementsManagement.status.creating = true;
      state.loadIncrementsManagement.status.creatingFailed = false;
    },
    autoCreateLoadIncrementsResolve: (state) => {
      state.loadIncrementsManagement.status.creating = false;
      state.loadIncrementsManagement.status.creatingFailed = false;
    },
    autoCreateLoadIncrementsReject: (state) => {
      state.loadIncrementsManagement.status.creating = false;
      state.loadIncrementsManagement.status.creatingFailed = true;
    },
    applyTempLoadIncrementsToWorksheet: (state) => {
      state.loadIncrementsManagement.status.submitting = true;
      state.loadIncrementsManagement.status.submissionFailed = false;
    },
    applyTempLoadIncrementsToWorksheetResolve: (state) => {
      state.loadIncrementsManagement.status.submitting = false;
    },
    applyTempLoadIncrementsToWorksheetReject: (state) => {
      state.loadIncrementsManagement.status.submitting = false;
      state.loadIncrementsManagement.status.submissionFailed = true;
    },
    updateLoadIncrements: (state) => {
      state.loadIncrementsManagement.status.synchronising = true;
      state.loadIncrementsManagement.status.synchronisingFailed = false;
    },
    updateLoadIncrementsResolve: (state) => {
      state.loadIncrementsManagement.status.synchronising = false;
    },
    updateLoadIncrementsReject: (state) => {
      state.loadIncrementsManagement.status.synchronising = false;
      state.loadIncrementsManagement.status.synchronisingFailed = true;
    },
    addTempLoadIncrement: (state, action: AddTempLoadIncrementAction) => {
      const { payload: { index } = {} } = action;
      state.loadIncrementsManagement.loadIncrements = [
        ...state.loadIncrementsManagement.loadIncrements.slice(0, index),
        { LoadIncrementID: Guid.create().toString() },
        ...state.loadIncrementsManagement.loadIncrements.slice(index),
      ].map((r, i) =>
        Object.assign({}, r, {
          IncrementIndex: i,
        })
      );
    },
    removeTempLoadIncrement: (state, action: RemoveTempLoadIncrementAction) => {
      if (!state.loadIncrementsManagement.loadIncrements) state.loadIncrementsManagement.loadIncrements = [];
      else state.loadIncrementsManagement.loadIncrements.splice(action.payload.index, 1);
      state.loadIncrementsManagement.loadIncrements = state.loadIncrementsManagement.loadIncrements.map((r, i) =>
        Object.assign({}, r, {
          IncrementIndex: i,
        })
      );
    },
    replaceTempLoadIncrement: (state, action: ReplaceTempLoadIncrementAction) => {
      const { payload: { index, value } = {} } = action;
      oPath.set(state.loadIncrementsManagement.loadIncrements, index, value);
    },
    setTempLoadIncrements: (state, action: SetTempLoadIncrementsAction) => {
      state.loadIncrementsManagement.loadIncrements = action.payload.loadIncrements;
    },
    setTempLoadIncrementValue: (state, action: SetTempLoadIncrementsValueAction) => {
      const { payload: { index, name, value } = {} } = action;
      oPath.set(state.loadIncrementsManagement.loadIncrements, `${index}.${name}`, value);
    },
  },
});

const { actions, reducer } = slice;

export { actions, reducer };
